import { ChaiApi } from "@chai/api-client";
import { type ReactNode, createContext, useContext } from "react";

export function createApiClientForBrowser(): ChaiApi {
  return new ChaiApi({ baseUrl: "/api" });
}

const ApiCtx = createContext<ChaiApi | null>(null);

export function ApiProvider({
  client,
  children,
}: {
  client: ChaiApi;
  children: ReactNode;
}) {
  return <ApiCtx.Provider value={client}>{children}</ApiCtx.Provider>;
}

export function useApi(): ChaiApi {
  const ctx = useContext(ApiCtx);
  if (!ctx) throw new Error("useApi() must be used inside <ApiProvider>");
  return ctx;
}
